import React, { Component } from 'react';
import Header from 'components/StaticPageHeader';
import NavOnScroll from 'components/NavOnScroll';
import Session from 'components/SessionReplica';
import renderIf from 'render-if';
import Tips from 'components/RecruitingTips';
import Myths from 'components/Myths';
import AboutTabs from 'components/AboutTabs';
import Footer from 'components/MiniFooter';
import { logPageView, initGA } from 'utils/analytics';
import { Helmet } from 'react-helmet';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import styles from './About.scss';// to import local scss fle

class About extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFixedNavbar: false,
      tab: 0,
    };
    this.handleScroll = this.handleScroll.bind(this);
    this.tabListener = this.tabListener.bind(this);
  }

  componentDidMount() {
    initGA();
    logPageView(this.props.match.path); // eslint-disable-line
    window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event) {
    const scrollTop = event.srcElement.body.scrollTop;
    if (scrollTop > 80) {
      this.setState({ showFixedNavbar: true });
    } else {
      this.setState({ showFixedNavbar: false });
    }
  }
  tabListener(tab) {
    this.setState({ tab });
  }
  render() {
    const { tab } = this.state;
    const renderAboutUs = renderIf(tab === 0);
    const renderMyths = renderIf(tab === 2);
    const renderTips = renderIf(tab === 1);
    return (
      <div className={cn('row', styles.container)}>
        <Helmet>
          <meta charSet="utf-8" />
          <title>MyRecruitBoard – Get Recruited. College Football Recruiting Never Stops!</title>
          <meta name="description" content="College Football Recruiting Never Stops!" />
          <meta
            name="Keywords" content="RECRUITING TIPS, RECRUITING Myths, SOPHOMORE RECRUITING TIPS,
            JUNIOR RECRUITING TIPS, SENIOR RECRUITING TIPS, FRESHMAN & MIDDLE SCHOOL RECRUITING TIPS,JUCO & COLLEGE TRANSFER RECRUITING TIPS "
          />
        </Helmet>
        {this.state.showFixedNavbar === true ? <NavOnScroll {...this.props} /> : ''}
        <Header page="about_us" {...this.props} />
        <div className={cn('col s12', styles.tabContainer)}>
          <AboutTabs
            {...this.state}
            tabListener={this.tabListener}
          />
        </div>
        {renderAboutUs(
          <div>
            <div className={styles.bigAboutUs}>
              <div className={cn('col s12', styles.content)}>
                <div className={cn('col s12 m6', styles.imageContainer)}>
                  <img alt="about feature" src="https://media.dev.myrecruitboard.com/Images/about1.jpg" />
                </div>
                <div className={cn('col s12 m6', styles.textContainer)}>
                  <div className={styles.darkHeader}>OVERVIEW</div>
                  <div className={styles.bigHeader}>
                    The most personalized college recruiting service yet.
                  </div>
                  <div className={styles.desc}>
                    Our goal is to make college football recruiting
                    more accessible through our Football Data Science
                    Technology. We&apos;ve made football exposure simpler and faster.
                    Don&apos;t waste your valuable time and money with &quot;free&quot;
                    recruiting phone consultations by other high cost recruiting
                    services. Join MyRecruitBoard today and you can start contacting
                    college coaches immediately. MyRecruitBoard represents a
                    new season in the relationship college coaches and football
                    players have with finding each other. We provide the best
                    exposure for college football recruiting.
                  </div>
                </div>
              </div>
              <div className={cn('col s12', styles.overviewContainer)}>
                <div className={cn('col s12 m6', styles.textContainer)}>
                  <div className={styles.darkHeader}>FEATURES</div>
                  <div className={styles.bigHeader}>
                    Football recruiting down to a science.
                  </div>
                  <div className={styles.darkHeader}>
                    SOCIAL NETWORKING INTEGRATIONS
                  </div>
                  <div className={styles.desc}>
                    We have the largest college football recruiting service on
                    Twitter. No other recruiting service covers every level of
                    college football more than we do. College coaches use our
                    Twitter more than any other social network to find new recruits.
                    Every member who upgrades their account receives unlimited
                    tweets and retweets during their entire paid recruiting process.
                    College Coaches watch our timeline and recruit the players who we
                    tweet about. MyRecruitBoard&apos;s social networking exposes a
                    detailed breakdown of your film, activities, camps, awards,
                    and accomplishment making it easier for college coach can find you
                  </div>
                  <div className={styles.darkHeader}>
                    DYNAMIC TOOLS
                  </div>
                  <div className={styles.desc}>
                    We have every football college in America on our website.
                    Our Football Data Science technology only matches you with
                    colleges that you directly match. Our technologies combine
                    college coach&apos;s biometric and academic requirements of recruits
                    so you increase your chances of being recruited. This ensures
                    college coaches are happy with the recruits contacting them
                    from our service. You must be a perfect fit in order to contact
                    college coaches. Join today and find out how many colleges
                    across America you match.
                  </div>
                </div>
                <div className={cn('col s12 m5', styles.imageContainer)}>
                  <img alt="about feature" src="https://media.dev.myrecruitboard.com/Images/about2.jpg" />
                </div>
              </div>
              <div className={cn('col s12', styles.technologyContainer)}>
                <div className={cn('col s12 m6', styles.imageContainer)}>
                  <img alt="about feature" src="https://media.dev.myrecruitboard.com/Images/about3.jpg" />
                </div>
                <div className={cn('col s12 m6', styles.textContainer)}>
                  <div className={styles.darkHeader}>TECHNOLOGY</div>
                  <div className={styles.bigHeader}>
                    How MyRecruitBoard Works.
                  </div>
                  <div className={styles.desc}>
                    <span className={styles.darkHeaderSmall}>Step 1:</span>
                    Every college football team in America has given us their ideal
                    football recruit&apos;s biometrics and academics.  We know things such as a
                    minimum GPA you&apos;ll need to attend their college, and height, weight,
                    and 40-Yard Dash time minimums for every position on their roster.<br /> <br />
                    <span className={styles.darkHeaderSmall}>Step 2:</span>
                    Based on the academic and biometric info you provide our
                    Football Data Science patent pending algorithm will match you to
                    every college in America which you are a direct fit.  Next you&apos;ll
                    need to contact each of these coaches after you upgrade. College
                    coaches will contact you on our site to find out more about you.<br /> <br />

                    <span className={styles.darkHeaderSmall}>Step 3:</span>
                    Get Recruited!
                  </div>
                </div>
              </div>
              <div className={cn('col s12', styles.overviewContainer)}>
                <div className={cn('col s12 m7', styles.textContainer)}>
                  <div className={styles.darkHeader}>DESIGN</div>
                  <div className={styles.bigHeader}>
                    We make it simple to get national exposure.
                  </div>
                  <div className={styles.desc}>
                    Coaches can view your profile on our website whenever
                    they want. Only upgraded members will be able to
                    contact coaches on our website. Additionally,
                    only paying members will be recommended to every
                    college in America when coaches search for prospects.
                  </div>
                </div>
                <div className={cn('col s12 m5', styles.imageContainer)}>
                  <img alt="about feature" src="https://media.dev.myrecruitboard.com/Images/about4.jpg" />
                </div>
              </div>
            </div>


            <div className={styles.smallAboutUs}>
              <div className={cn('col s12', styles.content)}>
                <div className={cn('col s12 m6', styles.textContainer)}>
                  <div className={styles.darkHeader}>OVERVIEW</div>
                  <div className={styles.bigHeader}>
                    The most personalized college recruiting service yet.
                  </div>
                  <div className={styles.desc}>
                    Our goal is to make college football recruiting
                    more accessible through our Football Data Science
                    Technology. We&apos;ve made football exposure simpler and faster.
                    Don&apos;t waste your valuable time and money with &quot;free&quot;
                    recruiting phone consultations by other high cost recruiting
                    services. Join MyRecruitBoard today and you can start contacting
                    college coaches immediately. MyRecruitBoard represents a
                    new season in the relationship college coaches and football
                    players have with finding each other. We provide the best
                    exposure for college football recruiting.
                   </div>
                </div>
                <div className={cn('col s12 m6', styles.imageContainer)}>
                  <img alt="about feature" src="https://media.dev.myrecruitboard.com/Images/about1.jpg" />
                </div>
              </div>
              <div className={cn('col s12', styles.content)}>
                <div className={cn('col s12 m6', styles.textContainer)}>
                  <div className={styles.darkHeader}>FEATURES</div>
                  <div className={styles.bigHeader}>
                    Football recruiting down to a science.
                  </div>
                  <div className={styles.darkHeader}>
                    SOCIAL NETWORKING INTEGRATIONS
                  </div>
                  <div className={styles.desc}>
                    We have the largest college football recruiting service on
                    Twitter. No other recruiting service covers every level of
                    college football more than we do. College coaches use our
                    Twitter more than any other social network to find new recruits.
                    Every member who upgrades their account receives unlimited
                    tweets and retweets during their entire paid recruiting process.
                    College Coaches watch our timeline and recruit the players who we
                    tweet about. MyRecruitBoard&apos;s social networking exposes a
                    detailed breakdown of your film, activities, camps, awards,
                    and accomplishment making it easier for college coach can find you
                  </div>
                  <div className={styles.darkHeader}>
                    DYNAMIC TOOLS
                  </div>
                  <div className={styles.desc}>
                    We have every football college in America on our website.
                    Our Football Data Science technology only matches you with
                    colleges that you directly match. Our technologies combine
                    college coach&apos;s biometric and academic requirements of recruits
                    so you increase your chances of being recruited. This ensures
                    college coaches are happy with the recruits contacting them
                    from our service. You must be a perfect fit in order to contact
                    college coaches. Join today and find out how many colleges
                    across America you match.
                  </div>
                </div>
                <div className={cn('col s12 m6', styles.imageContainer)}>
                  <img alt="about feature" src="https://media.dev.myrecruitboard.com/Images/about2.jpg" />
                </div>
              </div>
              <div className={cn('col s12', styles.technologyContainer)}>
                <div className={cn('col s12 m6', styles.textContainer)}>
                  <div className={styles.darkHeader}>TECHNOLOGY</div>
                  <div className={styles.bigHeader}>
                    How MyRecruitBoard Works.
                    </div>
                  <div className={styles.desc}>
                    <span className={styles.darkHeaderSmall}>Step 1:</span>
                    Every college football team in America has given us their ideal
                    football recruit&apos;s biometrics and academics.  We know things such as a
                    minimum GPA you&apos;ll need to attend their college, and height, weight,
                    and 40-Yard Dash time minimums for every position on their roster.<br /> <br />
                    <span className={styles.darkHeaderSmall}>Step 2:</span>
                    Based on the academic and biometric info you provide our
                    Football Data Science patent pending algorithm will match you to
                    every college in America which you are a direct fit.  Next you&apos;ll
                    need to contact each of these coaches after you upgrade. College
                    coaches will contact you on our site to find out more about you.<br /> <br />

                    <span className={styles.darkHeaderSmall}>Step 3:</span>
                     Get Recruited!
                    </div>
                </div>
                <div className={cn('col s12 m6', styles.imageContainer)}>
                  <img alt="about feature" src="https://media.dev.myrecruitboard.com/Images/about3.jpg" />
                </div>
              </div>
              <div className={cn('col s12', styles.technologyContainer)}>
                <div className={cn('col s12 m6', styles.textContainer)}>
                  <div className={styles.darkHeader}>DESIGN</div>
                  <div className={styles.bigHeader}>
                     We make it simple to get national exposure.
                  </div>
                  <div className={styles.desc}>
                    Coaches can view your profile on our website whenever
                    they want. Only upgraded members will be able to
                    contact coaches on our website. Additionally,
                    only paying members will be recommended to every
                    college in America when coaches search for prospects.
                </div>
                </div>
                <div className={cn('col s12 m6', styles.imageContainer)}>
                  <img alt="about feature" src="https://media.dev.myrecruitboard.com/Images/about4.jpg" />
                </div>
              </div>
            </div>
          </div>,
              )}
        {renderMyths(
          <Myths />,
          )}
        {renderTips(
          <Tips />,
          )}
        <div className={cn('col s12', styles.removePadding)}>
          <Footer />
        </div>
      </div>
    );
  }
}

export default Session(About);




// WEBPACK FOOTER //
// ./src/containers/About/About.js